import React, { useState } from 'react';
import { FileText, User, CheckCircle } from 'lucide-react';
import toast from 'react-hot-toast';

const LicenciasConduccion: React.FC = () => {
  const [formData, setFormData] = useState({
    // Datos personales
    tipoDocumento: '',
    numeroDocumento: '',
    nombre: '',
    apellido: '',
    fechaNacimiento: '',
    lugarNacimiento: '',
    direccion: '',
    telefono: '',
    email: '',
    
    // Datos de la licencia
    categoria: '',
    fechaExpedicion: '',
    fechaVencimiento: '',
    restricciones: '',
    observaciones: ''
  });

  const categorias = [
    'A1', 'A2', 'B1', 'B2', 'B3', 'C1', 'C2', 'C3', 'D1', 'D2'
  ];

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!formData.tipoDocumento || !formData.numeroDocumento || !formData.nombre) {
      toast.error('Por favor completa los datos personales');
      return;
    }
    
    if (!formData.categoria) {
      toast.error('Por favor selecciona una categoría de licencia');
      return;
    }
    
    toast.success('Licencia de conducción procesada exitosamente');
    console.log('Datos de la licencia:', formData);
  };

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <h1 className="text-2xl font-bold text-gray-900">Licencias de Conducción</h1>
        <p className="text-gray-600">Gestiona licencias de conducción y renovaciones</p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-8">
        {/* Datos Personales */}
        <div className="card p-6">
          <div className="flex items-center space-x-2 mb-6">
            <User className="w-6 h-6 text-primary-600" />
            <h2 className="text-xl font-semibold text-gray-900">Datos Personales</h2>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div>
              <label className="label">Tipo de Documento *</label>
              <select
                name="tipoDocumento"
                value={formData.tipoDocumento}
                onChange={handleInputChange}
                className="input"
                required
              >
                <option value="">Seleccione tipo</option>
                <option value="CC">Cédula de Ciudadanía</option>
                <option value="CE">Cédula de Extranjería</option>
                <option value="TI">Tarjeta de Identidad</option>
                <option value="RC">Registro Civil</option>
              </select>
            </div>
            
            <div>
              <label className="label">Número de Documento *</label>
              <input
                type="text"
                name="numeroDocumento"
                value={formData.numeroDocumento}
                onChange={handleInputChange}
                className="input"
                placeholder="Número de documento"
                required
              />
            </div>
            
            <div>
              <label className="label">Nombre *</label>
              <input
                type="text"
                name="nombre"
                value={formData.nombre}
                onChange={handleInputChange}
                className="input"
                placeholder="Nombre"
                required
              />
            </div>
            
            <div>
              <label className="label">Apellido *</label>
              <input
                type="text"
                name="apellido"
                value={formData.apellido}
                onChange={handleInputChange}
                className="input"
                placeholder="Apellido"
                required
              />
            </div>
            
            <div>
              <label className="label">Fecha de Nacimiento *</label>
              <input
                type="date"
                name="fechaNacimiento"
                value={formData.fechaNacimiento}
                onChange={handleInputChange}
                className="input"
                required
              />
            </div>
            
            <div>
              <label className="label">Lugar de Nacimiento</label>
              <input
                type="text"
                name="lugarNacimiento"
                value={formData.lugarNacimiento}
                onChange={handleInputChange}
                className="input"
                placeholder="Ciudad de nacimiento"
              />
            </div>
            
            <div className="md:col-span-2 lg:col-span-3">
              <label className="label">Dirección</label>
              <input
                type="text"
                name="direccion"
                value={formData.direccion}
                onChange={handleInputChange}
                className="input"
                placeholder="Dirección completa"
              />
            </div>
            
            <div>
              <label className="label">Teléfono</label>
              <input
                type="tel"
                name="telefono"
                value={formData.telefono}
                onChange={handleInputChange}
                className="input"
                placeholder="Teléfono"
              />
            </div>
            
            <div>
              <label className="label">Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                className="input"
                placeholder="Email"
              />
            </div>
          </div>
        </div>

        {/* Datos de la Licencia */}
        <div className="card p-6">
          <div className="flex items-center space-x-2 mb-6">
            <FileText className="w-6 h-6 text-primary-600" />
            <h2 className="text-xl font-semibold text-gray-900">Datos de la Licencia</h2>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            <div>
              <label className="label">Categoría *</label>
              <select
                name="categoria"
                value={formData.categoria}
                onChange={handleInputChange}
                className="input"
                required
              >
                <option value="">Seleccione categoría</option>
                {categorias.map(categoria => (
                  <option key={categoria} value={categoria}>{categoria}</option>
                ))}
              </select>
            </div>
            
            <div>
              <label className="label">Fecha de Expedición</label>
              <input
                type="date"
                name="fechaExpedicion"
                value={formData.fechaExpedicion}
                onChange={handleInputChange}
                className="input"
              />
            </div>
            
            <div>
              <label className="label">Fecha de Vencimiento</label>
              <input
                type="date"
                name="fechaVencimiento"
                value={formData.fechaVencimiento}
                onChange={handleInputChange}
                className="input"
              />
            </div>
            
            <div className="md:col-span-2 lg:col-span-3">
              <label className="label">Restricciones</label>
              <textarea
                name="restricciones"
                value={formData.restricciones}
                onChange={handleInputChange}
                className="input"
                rows={3}
                placeholder="Restricciones de la licencia"
              />
            </div>
            
            <div className="md:col-span-2 lg:col-span-3">
              <label className="label">Observaciones</label>
              <textarea
                name="observaciones"
                value={formData.observaciones}
                onChange={handleInputChange}
                className="input"
                rows={3}
                placeholder="Observaciones adicionales"
              />
            </div>
          </div>
        </div>

        {/* Información de Categorías */}
        <div className="card p-6">
          <div className="flex items-center space-x-2 mb-6">
            <CheckCircle className="w-6 h-6 text-primary-600" />
            <h2 className="text-xl font-semibold text-gray-900">Información de Categorías</h2>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            <div className="p-4 bg-blue-50 rounded-lg">
              <h4 className="font-medium text-blue-900 mb-2">A1, A2</h4>
              <p className="text-sm text-blue-700">Motocicletas</p>
            </div>
            <div className="p-4 bg-green-50 rounded-lg">
              <h4 className="font-medium text-green-900 mb-2">B1, B2, B3</h4>
              <p className="text-sm text-green-700">Vehículos particulares</p>
            </div>
            <div className="p-4 bg-yellow-50 rounded-lg">
              <h4 className="font-medium text-yellow-900 mb-2">C1, C2, C3</h4>
              <p className="text-sm text-yellow-700">Vehículos comerciales</p>
            </div>
            <div className="p-4 bg-purple-50 rounded-lg">
              <h4 className="font-medium text-purple-900 mb-2">D1, D2</h4>
              <p className="text-sm text-purple-700">Vehículos de servicio público</p>
            </div>
          </div>
        </div>

        {/* Botones de Acción */}
        <div className="flex justify-end space-x-4">
          <button type="button" className="btn btn-secondary">
            Cancelar
          </button>
          <button type="submit" className="btn btn-primary">
            <CheckCircle className="w-4 h-4 mr-2" />
            Procesar Licencia
          </button>
        </div>
      </form>
    </div>
  );
};

export default LicenciasConduccion;
